import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '../Button';

const StyledContainer = styled('div', {
  dynamic: ({ theme, isOpen, offset, contentWidth }) => {
    return {
      position: 'fixed',
      zIndex: 50,
      top: offset,
      right: isOpen ? contentWidth : 0,
      '@media print': {
        display: 'none',
      },
    };
  },
});

const StyledContent = styled('div', {
  dynamic: ({ theme, contentWidth, contentHeight }) => {
    return {
      width: contentWidth,
      height: contentHeight,
      position: 'absolute',
      top: 0,
      left: '100%',
      backgroundColor: 'white',
      boxShadow: 'rgba(0, 0, 0, 0.2) 0px 0px 8px 2px',
    };
  },
});

export const SideTab = ({
  children,
  isOpen,
  onClick,
  offset,
  contentWidth,
  content,
  variant,
  size,
  before,
  after,
  ...props
}) => {
  const sideNavRef = useRef();
  const contentHeight = sideNavRef.current ? sideNavRef.current.clientWidth : 0;

  return (
    <StyledContainer
      {...props}
      isOpen={isOpen}
      offset={offset}
      contentWidth={contentWidth}
      ref={sideNavRef}
    >
      {isOpen && (
        <StyledContent
          contentWidth={contentWidth}
          contentHeight={contentHeight}
        >
          {content}
        </StyledContent>
      )}
      <Button
        variant={variant}
        orientation="vertical"
        size={size}
        onClick={onClick}
        before={before}
        after={after}
        width={isOpen ? contentHeight : undefined}
        css={{
          height: 'auto',
          borderWidth: 1.25,
          borderRadius: '10px 10px 0 0',
          borderBottom: 'none',
          transform: 'rotate(-90deg) translate(0, -100%)',
          transformOrigin: '100% 0',
          lineHeight: '25px',
          padding: '5px 15px 2px 10px !important',
        }}
      >
        {children}
      </Button>
    </StyledContainer>
  );
};

SideTab.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
  offset: PropTypes.number,
  contentWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  content: PropTypes.node,
  variant: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  before: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  after: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};

SideTab.defaultProps = {
  children: null,
  isOpen: false,
  onClick: null,
  offset: 300,
  contentWidth: 300,
  content: null,
  variant: 'solid',
  size: 14,
  before: null,
  after: null,
};
